import React from 'react';
import { DarkSlateBlue } from '../../theme/colors';

const css = `

  body {
    -ms-overflow-style: none;
    scrollbar-width: none;
    overflow-y: hidden;
    display: block;
  }

  body::-webkit-scrollbar {
    display: none;
  }

  #shopify-section-announcement-bar {
    display: none;
  }

  #shopify-section-custom-announcement-bar {
    display: none;
  }

  .header-wrapper {
    display: none;
  }

  .site-box {
    display: block;
  }

  .hide-lt-600 {
    @media(height < 600px) {
      display: none;
    }
  }

  .hide-lt-700 {
    @media(height < 700px) {
      display: none;
    }
  }

  .disclaimer {
    font: 400 13px/1.67 Inter, sans-serif;
    color: ${DarkSlateBlue};
    text-align: center;

    & a {
      font: 400 12px/1.67 Inter, sans-serif;
      display:inline;
    }

    & a:any-link {
      color: ${DarkSlateBlue};
      text-decoration: underline;
      display:inline;
    }

    & a:-webkit-any-link {
      color: ${DarkSlateBlue};
      text-decoration: underline;
      display:inline;
    }

    & a.wide-primary {
      color: #ffffff;
      text-decoration: none;
      display:inline-block;
      font: 500 16px Inter, sans-serif;
    }
  }

`;

function GlobalStyle() {
  return (<style>{css}</style>);
}

export default GlobalStyle;
